import { render, staticRenderFns } from "./JudgesTypeLayout.vue?vue&type=template&id=49847c6e&scoped=true&"
import script from "./JudgesTypeLayout.vue?vue&type=script&lang=js&"
export * from "./JudgesTypeLayout.vue?vue&type=script&lang=js&"
import style0 from "./JudgesTypeLayout.vue?vue&type=style&index=0&id=49847c6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49847c6e",
  null
  
)

export default component.exports